import { render, staticRenderFns } from "./ProductGalleryItem.vue?vue&type=template&id=0fa019ef&scoped=true"
import script from "./ProductGalleryItem.vue?vue&type=script&lang=js"
export * from "./ProductGalleryItem.vue?vue&type=script&lang=js"
import style0 from "./ProductGalleryItem.vue?vue&type=style&index=0&id=0fa019ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa019ef",
  null
  
)

export default component.exports